// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Caan","label":"styles_label__3rw03"};